export default __webpack_public_path__ + "static/media/mt_lockup-color-glow.7207bb89.png";